import { render } from "./HomeFaqRefund.vue?vue&type=template&id=3f95ef02&scoped=true"
import script from "./HomeFaqRefund.vue?vue&type=script&lang=js"
export * from "./HomeFaqRefund.vue?vue&type=script&lang=js"

import "./HomeFaqRefund.vue?vue&type=style&index=0&id=3f95ef02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f95ef02"]])

export default __exports__